import React, { FC } from 'react';
import { Icon, IconProps } from '../Icon';

export const Error: FC<IconProps> = (props) => (
  <Icon {...props}>
    <path
      fill="currentColor"
      d="M12.71 6.13a3.76 3.76 0 0 1 6.52 0l9.22 15.98a3.76 3.76 0 0 1-3.26 5.64H6.75c-2.9 0-4.7-3.13-3.26-5.64l9.22-15.98Zm4.89.94a1.88 1.88 0 0 0-3.26 0L5.12 23.05a1.88 1.88 0 0 0 1.63 2.82h18.44a1.88 1.88 0 0 0 1.63-2.82L17.6 7.07Zm-1.62 14.1a.94.94 0 0 1 0 1.89h-.01a.94.94 0 0 1-.94-.94v-.01c0-.52.42-.94.94-.94Zm-.95-2.82v-4.7a.94.94 0 0 1 1.88 0v4.7a.94.94 0 0 1-1.88 0Z"
    />
  </Icon>
);
